// src/pages/VideoList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import Layout from '../components/Layout';
import Login from '../components/Login';
import './VideoList.css';

function VideoList() {
    const [videos, setVideos] = useState([]);
    const { currentUser, setAuthError } = useAuth();
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:5000/api';

useEffect(() => {
        const fetchVideos = async () => {
            if (currentUser) {
                try {
                    const idToken = await currentUser.getIdToken();
                    const response = await axios.get(`${backendUrl}/videos`, {
                        headers: {
                            'Authorization': `Bearer ${idToken}`
                        }
                    });
                    const sortedVideos = [...response.data].sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
                    setVideos(sortedVideos);
                    setAuthError(null);
                } catch (error) {
                    if (error.response && error.response.status === 403 && error.response.data.error === 'Unauthorized Access') {
                        // This is our specific backend authorization error
                        setAuthError(error.response.data.message);
                    } else {
                        console.error("Error fetching videos:", error);
                        setAuthError("An unexpected error occurred while fetching videos.");
                    }
                }
            } else {
                setAuthError(null); // Clear error if not logged in
                setVideos([]); // Clear videos if logged out
            }
        };

        fetchVideos();
    }, [currentUser, setAuthError]);

    if (!currentUser) {
        return (
            <div className="video-list-container">
                <Login className="login-button" />
            </div>
        );
    }
    return (
        <Layout>
            <div className="video-list-container">
                <h1 className="video-list-heading">Interviews</h1>
                <ul className="video-grid">
                    {videos.map(video => (
                        <li key={video.id} className="video-card">
                            <Link to={`/watch/${video.id}`} className="video-link">
                                <div className="video-thumbnail">
                                    {video.thumbnailUrl && <img src={video.thumbnailUrl} alt={video.name} />}
                                    {!video.thumbnailUrl && <img src={`https://via.placeholder.com/300x200?text=${encodeURIComponent(video.name)}`} alt={video.name} />}
                                </div>
                                <h2 className="video-title">{video.name}</h2>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </Layout>
    );
}

export default VideoList;